import {
  questionsByDimension,
  QuestionsByDimensionRequestParams,
} from "@/requests/questionnaries/questions-by-dimension.request";
import { useQuery } from "@tanstack/react-query";

export const buildQuestionsByDimensionQueryKey = (
  variables: QuestionsByDimensionRequestParams,
) => [
  "companies",
  variables.companyId,
  "quizzes",
  variables.applicationQuizId,
  "dimensions",
  variables.dimensionId,
  "questions",
];

export const useQuestionsByDimension = (
  variables: QuestionsByDimensionRequestParams,
) => {
  return useQuery({
    queryKey: buildQuestionsByDimensionQueryKey(variables),
    queryFn: () => questionsByDimension(variables),
    enabled: Object.values(variables).every(Boolean),
  });
};
